export default __webpack_public_path__ + "static/media/img_09.dd74a42f.webp";